import { ContentItem } from '..';

export class DividerContentItem extends ContentItem {
  constructor() {
    super();
    this._type = 'divider';
  }

  copy() {
    return new DividerContentItem();
  }

  toJson() {
    return {
      content_type: 'divider'
    };
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/content-items/divider-content-item.model.ts